document.addEventListener('alpine:init', () => {
  Alpine.data('responsiveImage', () => ({
    lottie: null,
    isVideoVisible: false,

    init() {
      if (+this.$root.dataset.first) {
        this.$root.parentElement.classList.add('first-on-phone');
      }

      this.$nextTick(() => this.ready());
    },

    ready() {
      if (this.$refs.lottie) {
        this.lottie = bodymovin.loadAnimation({
          container: this.$refs.lottie,
          path: this.$refs.lottie.dataset.file,
          renderer: 'svg',
          loop: !!+this.$refs.lottie.dataset.loop,
          autoplay: false,
        });
      }
    },

    play() {
      this.$nextTick(() => {
        const frame = this.lottie.currentFrame;
        this.lottie.setDirection(1);
        this.lottie.goToAndPlay(frame, true);
      });
    },

    openVideo() {
      if (!this.isVideoVisible) {
        this.isVideoVisible = true;
      }
    },

    closeVideo() {
      this.isVideoVisible = false;
    },

    parseYtUrl(url) {
      const parsed = new URL(url);
      const query = new URLSearchParams(parsed.search);
      const v = query.get('v');

      query.delete('v');
      query.set('autoplay', '1');

      return `https://www.youtube.com/embed/${v}?${query}`;
    },
  }));
});